import { MedicalSpecialty } from "../../models/digital-prompt-service/medical-specialty.model";
import { NatureOfAttendance } from "../../models/medical-record/nature-of-attendance";

export class MedicalSpecialtyCompletedStruct {
    public medicalSpecialty: MedicalSpecialty;
    public listNatureOfAttendance: NatureOfAttendance[] = [];
    public listHealthcareAgreement: any[] = [];
    public hasTheSelectedHealthcareAgreement: boolean;
}